import { create } from "zustand";

type SystemStatus = {
  showSessionPanel: boolean;
  sessionsWidth: number;
  showCanvasPanel: boolean;
  canvasWidth: number;
  isCanvasFullPage: boolean;
  isSessionPanelCollapsed: boolean;
  isMobileSessionPanelOpen: boolean;
};

type GlobalState = SystemStatus & {
  updateSystemStatus: (
    partial:
      | Partial<SystemStatus>
      | ((prev: SystemStatus) => Partial<SystemStatus>),
  ) => void;
};

export const useGlobalStore = create<GlobalState>()((set) => ({
  showSessionPanel: true,
  sessionsWidth: 240,
  showCanvasPanel: false,
  canvasWidth: 360,
  isCanvasFullPage: false,
  isSessionPanelCollapsed: false,
  isMobileSessionPanelOpen: false,
  updateSystemStatus: (partial) =>
    set((state) => {
      const prev: SystemStatus = {
        showSessionPanel: state.showSessionPanel,
        sessionsWidth: state.sessionsWidth,
        showCanvasPanel: state.showCanvasPanel,
        canvasWidth: state.canvasWidth,
        isCanvasFullPage: state.isCanvasFullPage,
        isSessionPanelCollapsed: state.isSessionPanelCollapsed,
        isMobileSessionPanelOpen: state.isMobileSessionPanelOpen,
      };
      const patch = typeof partial === "function" ? partial(prev) : partial;
      return { ...patch };
    }),
}));

export type { GlobalState, SystemStatus };
